
import "./checkout-submit-notification-v1"
import { CheckoutSummary } from '@yggdrasil/Checkout/V2/Services/checkout-summary'
import { formatNumberToCurrency } from '@yggdrasil/Utils/general'
import { computed, batched } from 'nanostores'
import { encodeVirtualInstallmentId, decodeVirtualInstallmentId } from '@yggdrasil/Checkout/V2/Services/checkout-store'
import { AVAILABLE_KLARNA_COUNTRIES } from "@yggdrasil/Checkout/V2/Services/checkout-utils"
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutMultiplePaymentsV2 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}







  devices = {
    'payment-card': undefined,
    paypal: undefined,
    'apple-pay': undefined,
    Klarna: undefined,
  }
  CARD_FIELDS = ['number', 'cvv', 'date']

  selectedPaymentTab = batched(
    [Checkout.store.payment.type, Checkout.store.payment.virtualInstallmentId],
    (paymentType, virtualInstallmentId) => {
      return paymentType === 'payment-card' && virtualInstallmentId !== null ? 'splitit' : paymentType
    }
  )

  mount () {
    this.cleanupPaymentOption('Klarna', () => !AVAILABLE_KLARNA_COUNTRIES.includes(globalThis.cfVisitorData.country))
    this.cleanupPaymentOption('apple-pay', () => !window.ApplePaySession)
    // TODO: make apple pay disabled when summary state. is != OK
    const form = document.querySelector('#cfAR')
     form.querySelectorAll('input[data-rebilly]').forEach((cfARInput) => {
      const dataRebillyAttribute = cfARInput.getAttribute('data-rebilly')
      const dataCfFormField = cfARInput.getAttribute('data-cf-form-field')
      const pageInputField = document.querySelector(`input[name="${dataCfFormField}"], select[name="${dataCfFormField}"]`)
      if (!pageInputField) {
        cfARInput?.removeAttribute('data-rebilly')
      } else {
        pageInputField?.setAttribute('data-rebilly', dataRebillyAttribute)
      }
    })

    Checkout.computed.modeLeaveEnterEvent.subscribe(ev => {
      const { leave, next, enter, previous } = ev
      const paymentState = Checkout.store.payment.state.get()
      if (paymentState == Checkout.PaymentStates.INITIALIZED) {
        if (leave && leave === this.mode) {
          this.unmountAllPaymentMethods()
        }
        if (enter === this.mode && previous) {
          this.mountRebillyElement()
        }
      }
    })

    Checkout.store.payment.state.listen((state) => {
      const checkoutMode = Checkout.store.checkout.mode.get()
      switch (state) {
        case Checkout.PaymentStates.LOADING: {
          if (this.mode == 'guest') this.showLoader()
          break
        }
        case Checkout.PaymentStates.INITIALIZED: {
          if (this.mode == 'guest') this.hideLoader()
          this.element.setAttribute('data-initialized', 'true')
          this.unmountAllPaymentMethods()
          if (this.mode == Checkout.store.checkout.mode.get()) this.mountRebillyElement()
          break
        }
      }
    })

    Checkout.computed.paymentErrors.subscribe((errors) => {
      const errorWrapper = this.element.querySelector('.elCheckoutFormErrors')
      errorWrapper.classList.add('elHide')
      this.element.classList.remove('hasPaymentError')
      if (Checkout.utils.hasErrors(errors)) {
        const isFocused = this.element.querySelector('.payment-card-fields-container-focus')
        const isMobile = this.element.clientWidth <= 770
        if (!isFocused || isMobile) {
          this.element.classList.add('hasPaymentError')
        }
        const fieldsErrors = errors.fields
        if (fieldsErrors) {
          const errors = []
          Object.entries(fieldsErrors).forEach(([field, error]) => {
            const {message} = error
            errors.push(message)
          })
          if (errors.length) {
            const listErrors = `<ul>${errors.map(err => `<li>${err}</li>`).join('')}</ul>`
            errorWrapper.innerHTML = listErrors
            errorWrapper.classList.remove('elHide')
          } else {
            errorWrapper.classList.add('elHide')
          }
        }
      }
    })

    Checkout.store.payment.type.listen((type) => {
      const paymentState = Checkout.store.payment.state.get()
      this.showPaymentType(type)
      this.unmountAllPaymentMethods()

      // NOTE: once paypal payment method is approved the only way to get rid of it is refreshing the window
      if (type == 'paypal' && Checkout.store.payment.paypal.state.get().state == Checkout.PaypalStates.PAYMENT_METHOD_APPROVED) return

      if (this.mode == Checkout.store.checkout.mode.get()) {
        if (paymentState === Checkout.PaymentStates.INITIALIZED) {
          this.mountRebillyElement()
        }
      }
    })

    Checkout.store.submitting.listen((value) => {
      const paymentType = Checkout.store.payment.type.get()
      const failedSubmit = value.state == Checkout.SubmittingStates.ERROR
      if (failedSubmit && paymentType == 'apple-pay' && this.mode == Checkout.store.checkout.mode.get()) {
        this.unmountAllPaymentMethods()
        this.mountRebillyElement()
      }
    })

    if (this.enabledPayments.includes('paypal')) {
      this.addPaypalEventListeners()
    }
    this.addPaymentEventListeners()
    this.initializeInstallments()
  }

  cleanupPaymentOption(paymentType, cleanupCallback) {
    const paymentIndex = this.enabledPayments.findIndex((v) => v == paymentType)
    if (cleanupCallback() && paymentIndex >= 0) {
      this.enabledPayments.splice(paymentIndex, 1)
    }

    const paymentElements = this.element.querySelectorAll(`[data-payment-type="${paymentType}"]`)
    if (!paymentElements.length) return

    if (cleanupCallback() || !this.enabledPayments.includes(paymentType)) {
      const isPaymentActive = paymentElements[0].getAttribute('data-active') == 'true'
      if (isPaymentActive && this.enabledPayments[0]) {
        this.showPaymentType(this.enabledPayments[0])
      }
      paymentElements.forEach(el => el.remove())
      if (this.enabledPayments.length <= 1) {
        this.element.querySelector('.pai-payment-methods')?.remove()
      }
    } else {
      paymentElements.forEach(el => el.classList.remove('elHide'))
    }
  }

  showLoader() {
    this.element.querySelector('.elPAILoader').dataset.loader = true
  }
  hideLoader() {
    this.element.querySelector('.elPAILoader').dataset.loader = false
  }

  addPaypalEventListeners() {
    Checkout.store.payment.paypal.state.listen((paypalState) => {
      switch (paypalState.state) {
        case Checkout.PaypalStates.IDLE: {
          this.paypalPreventClick()
          this.paypalInitializeContent()
          break;
        }
        case Checkout.PaypalStates.INITIALIZED: {
          this.paypalAllowClick()
          this.paypalInitializeContent()
          break;
        }
        case Checkout.PaypalStates.ERROR: {
          this.paypalPreventClick()
          switch (paypalState.code) {
            case Checkout.ErrorTypes.PAYPAL_DECLINED_ERROR: {
              const paypalStatus = this.getPaypalContent().querySelector('.paypal-status')
              paypalStatus.setAttribute('data-type', 'error')
              paypalStatus.innerText = this.checkoutMultiplePaymentsTexts.paypalDeclined;
              break;
            }
            case Checkout.ErrorTypes.PAYPAL_CUSTOM_ERROR: {
              const paypalStatus = this.getPaypalContent().querySelector('.paypal-status')
              paypalStatus.setAttribute('data-type', 'error')
              paypalStatus.innerText = paypalState.message
              break;
            }
          }
          break;
        }
        case Checkout.PaypalStates.PAYMENT_METHOD_APPROVED: {
          this.getPaypalContent().querySelector('.paypal-content-button-container').classList.add('elHide')
          const paypalStatus = this.getPaypalContent().querySelector('.paypal-status')
          paypalStatus.setAttribute('data-type', 'success')
          paypalStatus.innerHTML = `<i class="fas fa-check"></i> ${this.checkoutMultiplePaymentsTexts.yourPaymentIsConfigured}`
          break;
        }
      }
    })
  }

  getPaypalContent() {
    return this.element.querySelector('.paypal-content')
  }
  paypalInitializeContent() {
    this.getPaypalContent().querySelector('.paypal-status').innerHTML = ''
    this.getPaypalContent().querySelector('.paypal-content-button-container').classList.remove('elHide')
  }
  paypalPreventClick() {
    this.getPaypalContent().querySelector('.elSpinnerWrapper').dataset.loader = true
  }
  paypalAllowClick() {
    this.getPaypalContent().querySelector('.elSpinnerWrapper').dataset.loader = false
  }

  showPaymentType(type) {
    const paymentFields = this.element.querySelectorAll('.pai-payment-field')
    paymentFields.forEach((element) => {
      element.dataset.active = element.dataset.paymentType == type
    })
    const paymentContents = this.element.querySelectorAll('.pai-payment-content')
    paymentContents.forEach((element) => {
      element.dataset.active = element.dataset.paymentType == type
    })
  }

  addPaymentEventListeners() {
    const paymentFields = this.element.querySelectorAll('.pai-payment-field')

    paymentFields.forEach((element) => {
      element.addEventListener('click', (evt) => {
        evt.preventDefault();

        const paymentType = element.dataset.paymentType
        const actualPaymentType = element.dataset.actualPaymentType

        if (this.selectedPaymentTab.get() === paymentType) {
          return
        }

        // NOTE: in order to unmount payment-card we need to first check it was properly mounted.
        if (
            Checkout.store.payment.type.get() == 'payment-card' &&
            !Object.values(this.devices['payment-card'] ?? {}).every((v) => v?.element?.mounted)
        ) return

        // NOTE: once paypal payment method is approved the only way to get rid of it is refreshing the window
        if (this.enabledPayments.includes('paypal') && Checkout.store.payment.paypal.state.get().state != Checkout.PaypalStates.PAYMENT_METHOD_APPROVED) {
          Checkout.store.payment.paypal.state.set({ state: Checkout.PaypalStates.IDLE })
        }

        Checkout.store.payment['payment-card'].events.set({})
        Checkout.store.payment.type.set(actualPaymentType ?? paymentType)

        if (paymentType === 'splitit') {
          this.syncInstallments(true)
        } else {
          Checkout.store.payment.virtualInstallmentId.set(null)
        }
      })
    })
  }

  unmountPaymentMethod(type) {
    switch (type) {
      case 'apple-pay': {
        if (!this.devices['apple-pay']) break
        this.devices['apple-pay'].unmount()
        this.devices['apple-pay'] = undefined
        break
      }
      case 'paypal': {
        if (!this.devices.paypal) break
        this.devices.paypal.unmount()
        this.devices.paypal = undefined
        break
      }
      case 'payment-card': {
        if (!this.devices['payment-card']) break
        ["number", "cvv", "date"].forEach((key) => {
          this.devices['payment-card'][key].element.mounted && this.devices['payment-card'][key].destroy()
        })
        this.devices['payment-card'] = undefined
        break
      }
      case 'Klarna': {
        if (!this.devices.Klarna) break
        this.devices.Klarna.unmount()
        this.devices.Klarna = undefined
        break
      }
    }
  }

  unmountPaymentMethods(types) {
    types.forEach((type) => {
      this.unmountPaymentMethod(type)
    })
  }

  unmountAllPaymentMethods() {
    this.unmountPaymentMethods(this.enabledPayments)
  }

  mountRebillyElement() {
    const Rebilly = globalThis.Rebilly
    const paymentType = Checkout.store.payment.type.get()

    if (paymentType == 'apple-pay' && !this.devices['apple-pay']) {
      this.devices['apple-pay'] = Rebilly.applePay.mount(`[data-wrapper-checkout-state="${this.mode}"] .apple-pay-button`)
    }

    if (paymentType == 'payment-card' && !this.devices['payment-card']?.number) {
      const activeContent = this.element.querySelector(`.pai-payment-content[data-active="true"]`)
      const paymentCardWrapper = activeContent.querySelector('.payment-card-fields-container')

this.devices['payment-card'] = {}
      let lastEvent

      const mountNameMapper = {
        number: 'cardNumber',
        cvv: 'cardCvv',
        date: 'cardExpiration',
      }
      this.CARD_FIELDS.forEach((key) => {
        const mountPoint = paymentCardWrapper.querySelector(`.payment-card-${key}-mount`)
        const rebillyField = Rebilly.card.mount(mountPoint, mountNameMapper[key])
        const fieldElement = rebillyField.element.element.querySelector('.rebilly-framepay')
        rebillyField.on('focus', (ev) => {
          this.element.classList.remove('hasPaymentError')
          fieldElement.classList.add(`payment-card-field-focus`)
          paymentCardWrapper.classList.add('payment-card-fields-container-focus')
          Checkout.store.payment['payment-card'].events.setKey(key, undefined)
          lastEvent = null
        })
        rebillyField.on('change', (ev) => {
          lastEvent = ev
        })
        rebillyField.on('blur', (ev) => {
          fieldElement.classList.remove(`payment-card-field-focus`)
          paymentCardWrapper.classList.remove('payment-card-fields-container-focus')
          Checkout.store.payment['payment-card'].events.setKey(key, lastEvent)
        })
        this.devices['payment-card'][key] = rebillyField
      })
    } else if (paymentType == 'paypal') {
      this.devices.paypal = Rebilly.paypal.mount(`[data-wrapper-checkout-state="${this.mode}"] .paypal-mount`, { extraData: Checkout.PaypalCallbacks })
    } else if (paymentType == 'Klarna') {
      this.devices.Klarna = Rebilly.klarna.mount(`[data-wrapper-checkout-state="${this.mode}"] .klarna-mount`)
    }
  }

  initializeInstallments() {
    if (!this.enabledPayments.includes('splitit')) return

    const installmentsContainer = this.element.querySelector('.installments-container')
    const installmentsButton = this.element.querySelector('.installments-custom-dropdown-button')
    const dropdownOptions = this.element.querySelector('.installments-dropdown-options')
    const arrow = this.element.querySelector('.installments-dropdown-arrow')

    if (this.mode === Checkout.store.checkout.mode.get()) {
      const initialInstallmentsInput = this.element.querySelector('input[name="initial_installments_value"]')
      if (initialInstallmentsInput) {
        const value = initialInstallmentsInput.value
        Checkout.store.payment.virtualInstallmentId.set(value)
        this.syncInstallments()
      }
    }

    Checkout.computed.checkoutCart.listen((cart) => {
      if (this.mode !== Checkout.store.checkout.mode.get()) return
      this.syncInstallments()
    })

    Checkout.store.summary.listen((summaryState) => {
      if (this.mode !== Checkout.store.checkout.mode.get()) return
      this.syncInstallments()
    })

    installmentsButton.addEventListener('click', (evt) => {
      evt.preventDefault()
      evt.stopPropagation()

      const isOpen = dropdownOptions.style.display === 'block'
      dropdownOptions.style.display = isOpen ? 'none' : 'block'
      arrow.classList.toggle('open', !isOpen)
    })

    document.addEventListener('click', (evt) => {
      const isClickInside = installmentsContainer.contains(evt.target)
      if (!isClickInside && dropdownOptions.style.display === 'block') {
        this.closeinstallmentsDropdown()
      }
    })

    this.selectedPaymentTab.listen((selectedTab, oldSelectedTab) => {
      if (this.mode !== Checkout.store.checkout.mode.get()) return

      this.showPaymentType(selectedTab)

      const shouldRemount = Checkout.store.payment.state.get() == Checkout.PaymentStates.INITIALIZED
        && ((selectedTab == 'splitit' || oldSelectedTab == 'payment-card') || 
        (selectedTab == 'payment-card' || oldSelectedTab == 'splitit'))

      if (shouldRemount) {
        if (this.devices['payment-card']) {
          this.unmountPaymentMethod('payment-card')
        }
        this.mountRebillyElement()
      }
    })
  }

  syncInstallments(forceSelection = false) {
    const installmentsContainer = this.element.querySelector('.installments-container')
    const dropdownOptions = this.element.querySelector('.installments-dropdown-options')

    const cart = Checkout.computed.checkoutCart.get()
    const hasRecurringPrice = cart.items.some(({ price_id }) => {
      const price = globalThis.globalResourceData.pricesById[price_id]
      return price.is_recurring
    })

    const hasFreeTrial = cart.items.some(({ price_id }) => {
      const price = globalThis.globalResourceData.pricesById[price_id]
      return price.initial_price_cents === 0 || !price.initial_price_cents
    })

    const hasNonBumpProducts = cart.items.some(({ product_id }) => {
      return !globalThis.Checkout.productsById[product_id]?.bump
    })

    if (hasRecurringPrice || hasFreeTrial || cart.items.length === 0 || !hasNonBumpProducts) {
      this.disableInstallments()
      return
    }

    let totalAmount = 0
    let currencySymbol = Checkout.products[0].variants[0].currency

    const summaryState = Checkout.store.summary.get()
    if (summaryState?.data?.total?.amount) {
      const summaryData = summaryState.data
      totalAmount = summaryData.total.amount
      if (summaryData.currency_symbol) {
        currencySymbol = summaryData.currency_symbol
      }
    } else {
      const cartItems = Checkout.computed.checkoutCart.get().items
      if (!cartItems || cartItems.length === 0) {
        this.disableInstallments()
        return
      }

      Object.values(cartItems).forEach((item) => {
        const priceId = item.price_id
        const quantity = item.quantity || 1
        const priceData = globalResourceData.pricesById?.[priceId]
        if (priceData?.initial_price_cents) {
          totalAmount += (priceData.initial_price_cents / 100) * quantity
        }
      })
    }

    if (totalAmount <= 0) {
      this.disableInstallments()
      return
    }

    const currentVirtualId = Checkout.store.payment.virtualInstallmentId.get()

    // NOTE: Enable installments
    const installmentsTab = this.element.querySelector('[data-payment-type="splitit"]')
    const installmentsContent = this.element.querySelector('.installments-content')
    installmentsTab.classList.remove('elHide')
    installmentsContent.classList.remove('elHide')

    const tabSelector = this.element.querySelector('.pai-payment-methods')
    tabSelector?.classList.remove('elHide')

    if (!currentVirtualId && !forceSelection) {
      this.disableInstallments(false)
      return
    }

    const installmentOptions = globalResourceData.installments
      .map(inst => ({
        duration: inst.duration,
        type: inst.installment_type
      }))

    let optionsHTML = ''
    installmentOptions.forEach(({ duration, type }) => {
      if (duration >= 2 && duration <= 12) {
        const amountPerInstallment = Math.floor((totalAmount / duration) * 100) / 100
        const formattedAmount = formatNumberToCurrency(currencySymbol, amountPerInstallment)
        const scheduleText = 'every month'
        const virtualId = encodeVirtualInstallmentId(duration, type)

        optionsHTML += `
          <div class="installments-dropdown-option" data-virtual-id="${virtualId}" data-count="${duration}" data-amount="${amountPerInstallment}" data-currency="${currencySymbol}" data-type="${type}">
            <div>
              <div class="installments-option-text">${duration} payments</div>
              <div class="installments-option-schedule">${scheduleText}</div>
            </div>
            <div class="installments-dropdown-option-amount">${formattedAmount}</div>
          </div>
        `
      }
    })

    dropdownOptions.innerHTML = optionsHTML

    dropdownOptions.querySelectorAll('.installments-dropdown-option').forEach((option) => {
      option.addEventListener('click', () => {
        const count = parseInt(option.getAttribute('data-count'), 10)
        const amount = parseFloat(option.getAttribute('data-amount'))
        const currency = option.getAttribute('data-currency')
        const type = option.getAttribute('data-type')
        this.selectInstallmentPlan(count, amount, currency, type)
      })
    })

    const currentVirtualIdParsed = decodeVirtualInstallmentId(currentVirtualId)

    if (installmentOptions.length > 0) {
      const isCurrentValid = currentVirtualIdParsed && installmentOptions.some(
        opt => opt.duration === currentVirtualIdParsed.duration && opt.type === currentVirtualIdParsed.type
      )
      const shouldPreserveSelection = !forceSelection && isCurrentValid

      if (shouldPreserveSelection && currentVirtualIdParsed) {
        const currentAmount = Math.floor((totalAmount / currentVirtualIdParsed.duration) * 100) / 100
        this.selectInstallmentPlan(currentVirtualIdParsed.duration, currentAmount, currencySymbol, currentVirtualIdParsed.type)
      } else {
        const first = installmentOptions[0]
        const firstAmount = Math.floor((totalAmount / first.duration) * 100) / 100
        this.selectInstallmentPlan(first.duration, firstAmount, currencySymbol, first.type)
      }
    }
  }

  closeinstallmentsDropdown() {
    const dropdownOptions = this.element.querySelector('.installments-dropdown-options')
    const arrow = this.element.querySelector('.installments-dropdown-arrow')

    dropdownOptions.style.display = 'none'
    arrow.classList.remove('open')
  }

  selectInstallmentPlan(count, amount, currencySymbol, type = 'monthly') {
    const selectedText = this.element.querySelector('.installments-selected-text')
    const selectedSchedule = this.element.querySelector('.installments-selected-schedule')
    const formattedAmount = formatNumberToCurrency(currencySymbol, amount)
    selectedText.textContent = `${count} payments`
    selectedSchedule.textContent = formattedAmount

    const previewAmount = this.element.querySelector('.installments-preview-amount')
    const previewSchedule = this.element.querySelector('.installments-preview-schedule')
    previewAmount.textContent = formattedAmount
    const scheduleText = 'per month'
    previewSchedule.textContent = `${scheduleText} × ${count} payments`

    const scheduleContainer = this.element.querySelector('.installments-payment-schedule')
    const today = new Date()
    const dates = this.getinstallmentsDates(today, count, type)

    let html = ''
    dates.forEach((date, index) => {
      const displayDate = index === 0 ? 'Today' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
      html += `
        <div class="installments-schedule-item">
          <span>Payment ${index + 1} (${displayDate})</span>
          <span class="installments-schedule-amount">${formattedAmount}</span>
        </div>
      `
    })
    scheduleContainer.innerHTML = html

    const virtualId = encodeVirtualInstallmentId(count, type)
    Checkout.store.payment.virtualInstallmentId.set(virtualId)
    this.closeinstallmentsDropdown()
  }

  getinstallmentsDates(startDateObj, count, type = 'monthly') {
    const result = []

    if (type === 'monthly') {
      const startDay = startDateObj.getDate()
      const startMonth = startDateObj.getMonth()
      const startYear = startDateObj.getFullYear()

      for (let i = 0; i < count; i++) {
        const newDate = new Date(startYear, startMonth + i, startDay)

        if (newDate.getDate() !== startDay) {
          newDate.setDate(0)
        }

        result.push(newDate)
      }
    }

    return result
  }

  disableInstallments(hideTab = true) {
    const installmentsTab = this.element.querySelector('[data-payment-type="splitit"]')
    const installmentsContent = this.element.querySelector('.installments-content')
    installmentsContent.classList.add('elHide')
    Checkout.store.payment.virtualInstallmentId.set(null)

    if (hideTab) {
      installmentsTab.classList.add('elHide')
      // NOTE: if it only has splitit and card payment methods, it should hide tabs selector
      if (this.enabledPayments.length === 2) {
        const tabSelector = this.element.querySelector('.pai-payment-methods')
        if (tabSelector) {
          tabSelector.classList.add('elHide')
        }
      }
    }
  }



}

registerComponent('CheckoutMultiplePayments/V2', CheckoutMultiplePaymentsV2)
window["CheckoutMultiplePaymentsV2"] = CheckoutMultiplePaymentsV2

